import type { RicosFunctionalExtension } from 'ricos-types';

export const createRicosFunctionalExtension = <Options = unknown, Storage = unknown>(
  extension: RicosFunctionalExtension<Options, Storage>
): RicosFunctionalExtension<Options, Storage> => extension;
